import $ from "jquery";

$(function () {
	let moreBtn = $(".header .more-trigger, .header .close-more-menu, .header .btn-menu");

	moreBtn.on("click", function (e) {
		e.preventDefault();
		$("body, html").toggleClass("js-more-menu-open");
	});

	$(".more-nav .menu-item a").on("click", function () {
		$("body, html").toggleClass("js-more-menu-open");
	});

	$(window).on('scroll', function() {
        if ($(this).scrollTop() > 100) {
			// $('.header').addClass('blurred');
			// if ($(window).width() > 768) { 
				$('.header').addClass('page-scrolled');
			// }
        } else {
			// $('.header').removeClass('blurred');
			// if ($(window).width() > 768) { 
				$('.header').removeClass('page-scrolled');
			// }
        }
    });
});
